import script from "./translations.vue?vue&type=script&lang=ts&setup=true"
export * from "./translations.vue?vue&type=script&lang=ts&setup=true"

import "./translations.vue?vue&type=style&index=0&id=ddf67a12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddf67a12"]])

export default __exports__